import type { Momento } from "@caint/engine";
import * as rel from "@caint/relatorio";
import type { EntradaAnalise } from "@caint/relatorio";
import type { ItemMerged } from "../state/useAppState.ts";
import { engine } from "./engine.ts";

/**
 * Adaptador do frontend para `@caint/relatorio`: injeta a instância única do
 * motor (`engine`, config padrão v4.0) nas agregações puras do Relatório
 * Executivo, mantendo as assinaturas que os componentes já consomem (sem o
 * parâmetro `engine`). A lógica vive no pacote compartilhado.
 */

export {
  META_SUBINDICE,
  META_PRATA,
  GATILHO_PLANO,
  contarPlano,
  imgqComPeso,
  mediaScoreClasse,
  planoMeta,
} from "@caint/relatorio";

export type {
  Severidade,
  ResumoSetor,
  ResumoMacro,
  ResumoEixo,
  DistConformidade,
  PontoRisco,
  DistRisco,
  Finding,
  EntradaAnalise,
  MatSim,
  ImgqSim,
  PassoPlano,
  PlanoMeta,
} from "@caint/relatorio";

export const porSetor = (items: readonly ItemMerged[], momento: Momento): rel.ResumoSetor[] =>
  rel.porSetor(engine, items, momento);

export const porMacro = (items: readonly ItemMerged[], momento: Momento): rel.ResumoMacro[] =>
  rel.porMacro(engine, items, momento);

export const porEixo = (items: readonly ItemMerged[], momento: Momento): rel.ResumoEixo[] =>
  rel.porEixo(engine, items, momento);

export const distConformidade = (items: readonly ItemMerged[], momento: Momento): rel.DistConformidade =>
  rel.distConformidade(engine, items, momento);

export const distRisco = (items: readonly ItemMerged[], momento: Momento): rel.DistRisco =>
  rel.distRisco(engine, items, momento);

export const analiseCritica = (e: EntradaAnalise): rel.Finding[] => rel.analiseCritica(engine, e);
